import React from 'react';
import PropTypes from 'prop-types';

class ElsCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: typeof props.initialState !== 'undefined' ? props.initialState : true,
    };
  }

  checkEvent = () => {
    this.setState((prevState) => ({
      checked: !prevState.checked,
    }));
  };

  render() {
    const {
      description,
      name,
      value,
      label,
      addLink = false,
    } = this.props;
    const inputId = `checkbox-${name}`;
    return (
      <label className="els-form-checkbox" htmlFor={inputId}>
        <input
          checked={this.state.checked}
          className="els-form-checkbox-input"
          title={description}
          id={inputId}
          name={name}
          type="checkbox"
          value={value}
          onChange={this.checkEvent}
        />
        <span className="els-form-checkbox-visual" />
        <span className="els-form-checkbox-label">
          {label}
          { addLink && <a href="https://www.elsevier.com/en-gb/about/our-business/locations" target="_blank" rel="noopener noreferrer">  affiliates.</a>}
        </span>
      </label>
    );
  }
}

ElsCheckbox.propTypes = {
  description: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  initialState: PropTypes.bool,
  addLink: PropTypes.bool,
};

export default ElsCheckbox;
